"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceHelper = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const AssetModels_1 = require("../Models/AssetModels");
exports.BalanceHelper = {
    getBalanceCurrencyOb(balances) {
        const swapBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const cmSwapBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const tradeBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const debtBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const arbitrageStrategyBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const depositBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const dualBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const dualAutoBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        const moduleFinanceBalance = {
            totalChangePercent: 0,
            totalChangeValue: 0,
            total: 0,
            currency: "USD",
            totalUSD: 0,
            totalBTC: 0,
            totalChange: 0,
            balances: [],
        };
        balances.forEach((value) => {
            var _a, _b, _c, _d, _e, _f;
            const balance = new trade_utils_lib_1.SafeDecimal(value.balance);
            const btcPrice = new trade_utils_lib_1.SafeDecimal(value.btcPrice);
            const usdPrice = new trade_utils_lib_1.SafeDecimal(value.usdPrice);
            if (value.balanceType === AssetModels_1.BALANCE_TYPE_V2.TRADE) {
                tradeBalance.totalBTC = balance.mul(btcPrice).add(new trade_utils_lib_1.SafeDecimal(tradeBalance.totalBTC)).toNumber();
                tradeBalance.totalUSD = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(tradeBalance.totalUSD)).toNumber();
                tradeBalance.total = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(tradeBalance.total)).toNumber();
            }
            else if (value.balanceType === AssetModels_1.BALANCE_TYPE_V2.DEBT) {
                debtBalance.totalBTC = balance.mul(btcPrice).add(new trade_utils_lib_1.SafeDecimal(debtBalance.totalBTC)).toNumber();
                debtBalance.totalUSD = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(debtBalance.totalUSD)).toNumber();
                debtBalance.total = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(debtBalance.total)).toNumber();
            }
            else if (value.balanceType === AssetModels_1.BALANCE_TYPE_V2.SWAP) {
                swapBalance.totalBTC = balance
                    .add((_a = value.unrealizedProfit) !== null && _a !== void 0 ? _a : 0)
                    .mul(btcPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(swapBalance.totalBTC))
                    .toNumber();
                swapBalance.totalUSD = balance
                    .add((_b = value.unrealizedProfit) !== null && _b !== void 0 ? _b : 0)
                    .mul(usdPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(swapBalance.totalUSD))
                    .toNumber();
                swapBalance.total = balance
                    .add((_c = value.unrealizedProfit) !== null && _c !== void 0 ? _c : 0)
                    .mul(usdPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(swapBalance.total))
                    .toNumber();
            }
            else if (value.balanceType === AssetModels_1.BALANCE_TYPE_V2.ARBITRAGE_STRATEGY) {
                arbitrageStrategyBalance.totalBTC = balance
                    .mul(btcPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(arbitrageStrategyBalance.totalBTC))
                    .toNumber();
                arbitrageStrategyBalance.totalUSD = balance
                    .mul(usdPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(arbitrageStrategyBalance.totalUSD))
                    .toNumber();
                arbitrageStrategyBalance.total = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(arbitrageStrategyBalance.total)).toNumber();
            }
            else if (value.balanceType === AssetModels_1.BALANCE_TYPE_V2.CM_SWAP) {
                cmSwapBalance.totalBTC = balance
                    .add((_d = value.unrealizedProfit) !== null && _d !== void 0 ? _d : 0)
                    .mul(btcPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(cmSwapBalance.totalBTC))
                    .toNumber();
                cmSwapBalance.totalUSD = balance
                    .add((_e = value.unrealizedProfit) !== null && _e !== void 0 ? _e : 0)
                    .mul(usdPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(cmSwapBalance.totalUSD))
                    .toNumber();
                cmSwapBalance.total = balance
                    .add((_f = value.unrealizedProfit) !== null && _f !== void 0 ? _f : 0)
                    .mul(usdPrice)
                    .add(new trade_utils_lib_1.SafeDecimal(cmSwapBalance.total))
                    .toNumber();
            }
            else if (value.balanceType === AssetModels_1.BALANCE_TYPE_V2.DEPOSIT) {
                depositBalance.totalBTC = balance.mul(btcPrice).add(new trade_utils_lib_1.SafeDecimal(depositBalance.totalBTC)).toNumber();
                depositBalance.totalUSD = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(depositBalance.totalUSD)).toNumber();
                depositBalance.total = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(depositBalance.total)).toNumber();
            }
            else if (value.balanceType === AssetModels_1.BALANCE_TYPE_V2.DUAL) {
                dualBalance.totalBTC = balance.mul(btcPrice).add(new trade_utils_lib_1.SafeDecimal(dualBalance.totalBTC)).toNumber();
                dualBalance.totalUSD = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(dualBalance.totalUSD)).toNumber();
                dualBalance.total = balance.mul(usdPrice).add(new trade_utils_lib_1.SafeDecimal(dualBalance.total)).toNumber();
            }
        });
        balances.forEach((item) => {
            const currencyResult = {
                base: item.currency,
                baseDisplay: item.currencyAlias || item.currency,
                quantity: item.balance,
                frozen: item.frozen,
                available: new trade_utils_lib_1.SafeDecimal(item.available).toNumber(),
                currency: "USD",
                USD: new trade_utils_lib_1.SafeDecimal(item.balance).mul(item.usdPrice).toNumber(),
                BTC: new trade_utils_lib_1.SafeDecimal(item.balance).mul(item.btcPrice).toNumber(),
                USDPrice: item.usdPrice,
                BTCPrice: item.btcPrice,
                USDPriceChange: item.usdChangePercent,
                fullName: item.fullName,
                balanceType: item.balanceType,
            };
            if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.DEBT) {
                debtBalance.balances.push(Object.assign(Object.assign({}, currencyResult), { frozen: currencyResult.available, available: 0 }));
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.TRADE) {
                tradeBalance.balances.push(currencyResult);
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.ARBITRAGE_STRATEGY) {
                arbitrageStrategyBalance.balances.push(currencyResult);
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.CM_SWAP) {
                currencyResult.unrealizedProfit = item.unrealizedProfit;
                cmSwapBalance.balances.push(currencyResult);
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.SWAP) {
                currencyResult.unrealizedProfit = item.unrealizedProfit;
                swapBalance.balances.push(currencyResult);
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.DEPOSIT) {
                depositBalance.balances.push(currencyResult);
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.DUAL) {
                dualBalance.balances.push(currencyResult);
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.DUAL_AUTO) {
                dualAutoBalance.balances.push(currencyResult);
            }
            else if (item.balanceType === AssetModels_1.BALANCE_TYPE_V2.MODULE_FINANCE) {
                moduleFinanceBalance.balances.push(currencyResult);
            }
        });
        tradeBalance.balances.sort((a, b) => {
            return b.USD - a.USD;
        });
        swapBalance.balances.sort((a, b) => {
            return b.USD - a.USD;
        });
        debtBalance.balances.sort((a, b) => {
            return b.USD - a.USD;
        });
        arbitrageStrategyBalance.balances.sort((a, b) => {
            return b.USD - a.USD;
        });
        cmSwapBalance.balances.sort((a, b) => {
            return b.USD - a.USD;
        });
        depositBalance.balances.sort((a, b) => {
            return b.USD - a.USD;
        });
        return {
            trade: tradeBalance,
            debt: debtBalance,
            arbitrageStrategy: arbitrageStrategyBalance,
            swap: swapBalance,
            cmSwap: cmSwapBalance,
            deposit: depositBalance,
            dual: dualBalance,
            dualAuto: dualAutoBalance,
            moduleFinance: moduleFinanceBalance,
        };
    },
    /**
     * 理财资产:
     * 理财账户中除套利资产外的其他资产
     * @param balance useBalanceByAPIKey获取的资产余额
     */
    combineFinanceExceptArbitrage(balance) {
        if (!balance) {
            return [];
        }
        const { deposit, dual, dualAuto, moduleFinance } = balance;
        const balances = [...deposit.balances, ...dual.balances, ...dualAuto.balances, ...moduleFinance.balances];
        const balanceMap = new Map();
        balances.forEach((balance) => {
            const balance1 = balanceMap.get(balance.base);
            if (balance1) {
                const newBalance = {
                    base: balance.base,
                    baseDisplay: balance.baseDisplay,
                    quantity: new trade_utils_lib_1.SafeDecimal(balance.quantity || 0).add(balance1.quantity || 0).toNumber(),
                    frozen: new trade_utils_lib_1.SafeDecimal(balance.frozen || 0).add(balance1.frozen || 0).toNumber(),
                    available: new trade_utils_lib_1.SafeDecimal(balance.available || 0).add(balance1.available || 0).toNumber(),
                    currency: balance.currency,
                    USD: new trade_utils_lib_1.SafeDecimal(balance.USD || 0).add(balance1.USD || 0).toNumber(),
                    BTC: new trade_utils_lib_1.SafeDecimal(balance.BTC || 0).add(balance1.BTC || 0).toNumber(),
                    USDPrice: balance.USDPrice,
                    BTCPrice: balance.BTCPrice,
                    USDPriceChange: balance.USDPriceChange,
                    fullName: balance === null || balance === void 0 ? void 0 : balance.fullName,
                };
                balanceMap.set(balance.base, newBalance);
            }
            else {
                balanceMap.set(balance.base, Object.assign({}, balance));
            }
        });
        return Array.from(balanceMap.values());
    },
};
